import React from "react";
import type { ColumnSchema } from "../types";

type TextHeaderProps = {
  columnSchema: ColumnSchema;
};

export function TextHeader({ columnSchema }: TextHeaderProps) {
  const { label } = columnSchema;
  return <div className="cp-ellipsis">{label}</div>;
}
